import React from 'react';

import cx from 'classnames';
import format from 'date-fns/format';

import Button from 'components/shared/Button';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { getLocalDateFromString } from 'utils/date';

import ActionsMenu from '../../ActionsMenu';
import { EventList } from '../EventList';
import { useAddEventMenuActions, useCollapseDays } from '../functions';
import { IDayProps } from '../types';
import { useDay, useDayHeight } from './functions';
import { HiddenDays } from './HiddenDays';
import s from './index.module.css';

export const Day = ({ day }: IDayProps) => {
  const { isCollapsed } = useCollapseDays();
  const { calcDayHeight } = useDayHeight({ day, isCollapsed });
  const { showDates, showDay, onToggle, highlighted, dayRef } = useDay({ day });
  const addEventMenuActions = useAddEventMenuActions({ dayNumber: day.day, dayDate: day.date });
  const { isMobile } = useMediaBreakpoints();

  return (
    <div
      ref={(node) => {
        if (node) calcDayHeight(node);
        dayRef.current = node;
      }}
      className={cx(s.wrapper, { [s['wrapper-collapsed']]: isCollapsed })}
    >
      <div className={s.header}>
        <div className={s.dateContainer}>
          {!isMobile && <div className={s.bluePoint}></div>}
          <div className={s.title}>
            <div className={s.day}>
              {showDates ? format(getLocalDateFromString(day.date), 'MMM d, iii') : 'Day ' + day.day}
            </div>
          </div>
        </div>
        <div className={s.buttonsContainer}>
          {!isMobile && <HiddenDays showDay={showDay} onToggle={onToggle} day={day} />}
          <ActionsMenu className={s.actions} actions={addEventMenuActions}>
            <Button size="small" type="default">
              Add Event
            </Button>
          </ActionsMenu>
        </div>
      </div>
      {isMobile && <HiddenDays showDay={showDay} onToggle={onToggle} day={day} />}
      {(!isCollapsed || showDay) && <EventList events={day.tripEvents} highlighted={highlighted} />}
    </div>
  );
};
